
import { useState, useEffect, useRef } from 'react'

import {
    Init, sRef, ref, get, child, auth,
    getStorage, strRef,
    getDatabase, getDownloadURL
} from '../firebase'

import {
    Call, LinkedIn, Email, WhatsApp,
    Instagram, Website, WebsitePopup
} from '../../functions/actionFunctions'
import headerTile from '../../assets/images/headerTile.png'
import dynamicTile from '../../assets/images/dynamicTile.png'

import axios from 'axios'
import {
    Dialog, DialogContent, Button, Box,
    Stack, DialogActions, Typography
} from '@mui/material'
import { CheckPrototileConfiguration, CheckTileConfig, FetchIconTrayDetails, FetchUserFiles, FetchUserImages } from '../../functions/db-functions/profileFunctions'
import { PdfPopup } from '../PdfTile/PdfPopup'
import PrototileIconAR from '../Prototile/PrototileIcon'
import PdfTileIconAR from '../PdfTile/PdfTileIcon'
import ARcontactIcons from './ARcontactIcons'



export default function VisionAR({
    uid, profileHash, profileSnapshot,
    authStatus,
    uiVisible, setMode }) {

    const [fetched, setFetched] = useState(false)

    const [prototileState, setPrototileState] = useState({
        integrations: null,
        activeTile: null
    })

    const [pdfTileState, setPdfTileState] = useState({ activeTile: null })

    const [page, setPage] = useState("PageOne")

    const [pageOneFiles, setPageOneFiles] =
        useState({
            HeaderTile: headerTile,
            DynamicTile: dynamicTile,
            Logo: null,
            PDF: null
        })

    const [websitePopup, setWebsitePopup] = useState(null)

    /*     InitShader() */
    const [iconTrayDetails, setIconTrayDetails] =
        useState({
            Format: "",
            One: "Undefined",
            Two: "Undefined",
            Three: "Undefined",
            Four: "Undefined",
            Five: "Undefined",
            Six: "Undefined",
            Call: null,
            Email: null,
            Website: null,
            LinkedIn: null,
            WhatsApp: null,
            Location: null,
            Instagram: null
        })

    useEffect(() => {
        const inti = Init()
        const db = getDatabase()
        if (authStatus == "Completed" && !fetched && profileHash) {
            console.log("fetching")
            FetchUserFiles({profileHash, setPageOneFiles})
            FetchIconTrayDetails(uid, profileSnapshot, setIconTrayDetails)
            CheckTileConfig({uid, profileHash, profileSnapshot,
                setPageOneFiles, setPrototileState, setPdfTileState})
            console.log(pdfTileState.activeTile)
            setFetched(true)
        }
    }, [authStatus, fetched, auth.onAuthStateChanged, auth.currentUser, profileHash])



    function getProperties(link) {
        return ("shader:gif;transparent:true;src:url(" + link + ");opacity:0.99;")
    }

    return (<>

        {pdfTileState ?
            pdfTileState.activeTile == "PDF" ?
                <PdfPopup {...{ page, pageOneFiles, setPage }} /> :
                (<></>) : null
        }


        {/* {prototileState.activeTile != "Logo" ?
            <ProtoPopup {...{ page, setPage }} /> :
            (<></>)} */}

        <a-entity id="PortfolioOverlay"
            visible={uiVisible}
            portfolioanimations
            opacity="0" scale="1 1 1"
            position="0 0 0">
            <a-plane
                src={pageOneFiles.HeaderTile ? pageOneFiles.HeaderTile : headerTile}
                width="1"
                class="pageOne ui"
                shader="flat"
                height="0.7"
                opacity="0.99"
                position="0 0.75 0"
            ></a-plane>

            <ARcontactIcons {...{ iconTrayDetails }} />

            {prototileState ?
                prototileState.activeTile ?
                    (<PrototileIconAR {...{
                        prototileState,
                        pageOneFiles,
                        setPage,
                        setMode
                    }} />)
                    :
                    (<a-plane
                        src={pageOneFiles.DynamicTile}
                        width="0.5"
                        class="clickable button pageOne ui"
                        shader="flat"
                        height="0.5"
                        opacity="0.99"
                        scale="1 1 1"
                        position="-0.265 -0.6 0"
                    />) : null}

            {pdfTileState ?
                pdfTileState.activeTile ?
                    (<PdfTileIconAR {...{
                        pdfTileState,
                        pageOneFiles,
                        setPage
                    }} />)
                    :
                    (<></>) : null}

        </a-entity>

    </>
    )
}



